<h1 mat-dialog-title>Remove Guest</h1>
<div mat-dialog-content>
    <p>Confirm you would like to remove guest?</p>
</div>
<div mat-dialog-actions class="mt-2 d-flex justify-content-end">
    <button mat-raised-button (click)="onNoClick()">
        Cancel
    </button>
    <button mat-raised-button class="warn-button" (click)="onYesClick()">
        Delete
    </button>
</div>